/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseStudentProgressReportData } from './genericApiResponseStudentProgressReportData';
import type { GenericApiResponseStudentProgressReportMessage } from './genericApiResponseStudentProgressReportMessage';
import type { GenericApiResponseStudentProgressReportPagination } from './genericApiResponseStudentProgressReportPagination';
import type { GenericApiResponseStudentProgressReportError } from './genericApiResponseStudentProgressReportError';

export interface GenericApiResponseStudentProgressReport {
  data?: GenericApiResponseStudentProgressReportData;
  message?: GenericApiResponseStudentProgressReportMessage;
  pagination?: GenericApiResponseStudentProgressReportPagination;
  error?: GenericApiResponseStudentProgressReportError;
  statusCode?: number;
}
